import store from '@/store'

// 验证是否登录
export function authCheckLogin(){
    const isLogin = store.getters['loginModel/getLoginState']
    if(!isLogin){
        store.commit("manuAction/loginModelOpenCtr", true) // 打开注册登录框
    }
    return isLogin

}
// 改变vuex里信息 菜单是否打开
export function h5LeftMenuOpen(flag){
    store.commit("manuAction/h5LeftMenuOpenCtr",flag)
}
// 改变vuex里信息 注册框是否打开
export function registModelOpen(flag){
    store.commit("manuAction/registModelOpenCtr",flag)
}
// 改变vuex里信息 登录框是否打开
export function loginModelOpen(flag){
    store.commit("manuAction/loginModelOpenCtr",flag)
}
// 改变vuex里信息 找回密码框是否打开
export function findPasswordOpen(flag){
    store.commit("manuAction/findPasswordModelOpenCtr",flag)
}
// 退出登录
export function loginOut(){
    store.dispatch('loginModel/loginOut')
}
